import cookie from 'react-cookies';
import { Response } from 'express';
import { IncomingHttpHeaders, IncomingMessage } from 'http';
import get from 'lodash/get';
import { NextPageContext } from 'next';

import { setLogin } from '@r1-frontend/entities/stores/auth/actionCreators';
import { loginByAccessToken } from '@r1-frontend/entities/stores/auth/actions/loginByAccessToken';

import { getCityFromHostName } from '@r1-frontend/geo';

import { ACCESS_TOKEN_COOKIE, CITYDOMAIN_COOKIE } from '@r1-frontend/shared/constants';
import { isClientSide, isServerSide } from '@r1-frontend/shared/helpers/ssr';

import { AGREEMENT_ID_COOKIE } from '~/src/constants';
import { getCookie } from '~/src/helpers/cookie';

import { getHostNameFromUrl } from './url';

const getHostName = (req: IncomingMessage) => {
    const headers: IncomingHttpHeaders = get(req, 'headers');
    const headerHost = headers?.host || '';

    return isClientSide()
        ? getHostNameFromUrl(window.location)
        : headerHost && get(req, 'hostname', getHostNameFromUrl(headerHost));
};

const getAccessToken = (options: NextPageContext): string | undefined => {
    const { req } = options;

    if (isServerSide() && req) {
        const hostname = getHostName(req);
        const domain = getCityFromHostName(hostname);
        const accessToken = getCookie(ACCESS_TOKEN_COOKIE, req);

        // Кука CITYDOMAIN_COOKIE - устанавливается при авторизации, по домену авторизации.
        const cityDomainFromCookie = getCookie(CITYDOMAIN_COOKIE, req);
        // Возвращаем accessToken только если текущий домен совпадает с сохраненным в куке CITYDOMAIN_COOKIE, т.е. с тем под которым авторизовывались.
        return cityDomainFromCookie === domain ? accessToken : undefined;
    } else {
        return cookie.load(ACCESS_TOKEN_COOKIE);
    }
};

/**
 * Receiving data for every page.
 * May be called on Server side and Client side renders.
 * !!! We do not have the req/res on a client side !!!
 */
export const initialProps = async(
    ctx: NextPageContext,
    auth = { isNeedAuthData: true },
): Promise<{ validatedAccessToken: null | string }> => {
    const { req, res } = ctx;

    const accessToken = getAccessToken(ctx) ?? null;

    /**
     * This means that the parent methods getInitialProps()
     * are called on the client side. But we should always
     * return the accessToken from here
     */
    if (!req || !res) {
        return { validatedAccessToken: accessToken };
    }

    if (accessToken) {
        ctx.store.dispatch(setLogin({ accessToken, refreshToken: accessToken }));
    }
    /**
     * We should to collect data instead of dispatching it to store at the moment
     * response cannot be a take of part of redux action
     */
    if (auth.isNeedAuthData && accessToken) {
        // todo - remove prop drilling ad-hoc after avoiding requesting user data on ssr
        // task - https://ticket.ertelecom.ru/browse/WEB-45658
        const agreementNumber = getCookie(AGREEMENT_ID_COOKIE, req);

        // response cannot be a take of part of redux action
        // todo - убрать приведение типов при уходе от запроса данных пользователей на ssr
        const { isValidAccessToken } = await ctx.store.dispatch(loginByAccessToken(agreementNumber, res as unknown as Response));
        return { validatedAccessToken: isValidAccessToken ? accessToken : null };
    }

    return { validatedAccessToken: null };
};
